module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Waiting-b21daa1b0dbcdf1844be4291ac84359a.svg";